// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hqPd0","colBig":"styles_colBig__1WB8D","colSmall":"styles_colSmall__1KBkk"};